import * as React from 'react'
import dynamic from 'next/dynamic'

import {
  Hero,
  About,
  Benefits,
  RealWorld,
  Why,
  Customer,
  Iso,
  CustomAiFooter,
} from '@components/custom-ai'
import SiteHeader from '@components/SiteHeader'
import {Other} from '@components/custom-ai/Other'

const Meta = dynamic(() => import('@components/Meta'))

export default function CustomAi() {
  const EASING = [0.6, 0.01, -0.05, 0.95]

  const animationProps = (delay = 0) => {
    return {
      initial: {opacity: 0, y: 30},
      animate: {opacity: 1, y: 0},
      transition: {duration: 1, ease: EASING, delay},
    }
  }
  const scrollTo = (e) => {
    e.preventDefault()
    const id = e.currentTarget.hash
    window.history.pushState(null, null, id)

    document.querySelector(id)?.scrollIntoView({behavior: 'smooth'})
  }

  return (
    <React.Fragment>
      <Meta title='Custom AI | Datawow – Data Science Consultant Thailand | Data Wow in Bangkok' />
      <Hero animation={animationProps} scrollTo={scrollTo} />
      <About animation={animationProps} scrollTo={scrollTo} />
      <Benefits />
      <RealWorld />
      <Why />
      <Customer />
      <Iso />
      <Other />
    </React.Fragment>
  )
}
